const clickEventCloseStickyBar = {
	el: {
		container: document.querySelector('.js-sticky-bar'),
		closeButton: document.querySelector('.js-sticky-bar-button')
	},

	fxHandleClickEvent() {
		this.el.container.style.display = 'none'
	},

	events() {
		if (!this.el.container) return
		this.el.closeButton.addEventListener('click', () => this.fxHandleClickEvent())
	},
	init() {
		this.events()
	}
}

clickEventCloseStickyBar.init()